import { useEffect, useRef } from "react";
import { motion, useAnimation } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 32 }) => {
  const controls = useAnimation();
  const ref = useRef(null);
  const fired = useRef(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;

    const start = () => {
      if (fired.current) return;
      fired.current = true;
      controls.start({
        opacity: 1,
        y: 0,
        transition: { duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] },
      });
    };

    let io;
    if ("IntersectionObserver" in window) {
      io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              start();
              io.disconnect();
            }
          });
        },
        { rootMargin: "0px 0px -80px 0px" }
      );
      io.observe(el);
    }

    const fallback = window.setTimeout(start, 1100 + delay * 1000);

    return () => {
      if (io) io.disconnect();
      window.clearTimeout(fallback);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <motion.div ref={ref} className={className} initial={{ opacity: 0, y }} animate={controls}>
      {children}
    </motion.div>
  );
};
